export enum ActivityEventEmailOptionsEnum {
  Atendente = 'attendant',
  ClienteProspect = 'clientProspect',
  Ambos = 'both',
}
